import React from 'react'
import './Text.css'

export interface TextProps {
  children: React.ReactNode
  size?: 'small' | 'base' | 'large' | 'extra-large'
  color?: 'primary' | 'white' | 'brand' | 'gray'
  weight?: 'normal' | 'medium' | 'bold' | 'extra-bold'
  className?: string
}

export const Text: React.FC<TextProps> = ({
  children,
  size = 'base',
  color = 'primary',
  weight = 'normal',
  className = '',
}) => {
  const classes = [
    'text',
    `text-size-${size}`,
    `text-color-${color}`,
    `text-weight-${weight}`,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return <span className={classes}>{children}</span>
}
